export const SampleConstant = '{SampleConstant}';
export const BaseAPIUrl = '{BaseAPIUrl}';
export const SampleId = '{BaseAPIUrl}';
export const VersionId = '{VersionId}';
export const ProfileId = '{ProfileId}';
export const PlanId = '{PlanId}';
export const SubscriptionId = '{SubscriptionId}';
export const PreProdUrl = 'https://global-dev.amcom-corp-preprod.amway.net/comsubscriptionas';
export const API_VERSION_V1 = 'v1';
export const ErrorMsg = 'Please check arguments';
export const ElementId = '{ElementId}';
